let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("k3BGs"), load("ffEVr"), load("joJy8"), load("aHE9G"), load("lgZ1d")]).then(() => parcelRequire('kYnTG'));